import { useState, useEffect, useContext, useCallback } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

const usePlans = (countryCode = "IN", userId = "") => {
 const { baseUrl, basicAuth } = useContext(GlobalContext);

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

const fetchSubscriptionPlans = useCallback(async () => {
  setLoading(true);
  setError(null);

  try {
    const response = await axios.post(
      `${baseUrl}/Entitlement/fetchSubscriptionPlans`,
      {
        userid: userId,
        countryCode: countryCode,
      },
      {
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
      }
    );

    setPlans(response.data.data || []);
  } catch (err) {
    setError(err);
  } finally {
    setLoading(false);
  }
}, [baseUrl, countryCode, userId, basicAuth]);

  useEffect(() => {
    if (baseUrl) {
      fetchSubscriptionPlans();
    }
  }, [baseUrl, countryCode, userId]);

  return { plans, setPlans, loading, error, refetch: fetchSubscriptionPlans };
};

export default usePlans;